export class ResponseError {
	message: string
}